<template>
  <AccessibleButton
    :aria-label="label"
    class="button-control p-2 flex justify-center"
    :class="{ ['button-control--disabled']: disabled }"
    :disabled="disabled"
    :title="toolTip"
    show-on-hover
  >
    <template #icon>
      <span
        class="material-icons"
        aria-hidden="true"
        :class="{ ['material-icons--bigger']: bigger }"
        >{{ iconName }}</span
      >
    </template>
  </AccessibleButton>
</template>
<script setup lang="ts">
import { CommandProps } from "@/commands/props";
import AccessibleButton from "@/components/shared/AccessibleButton.vue";
import { computed } from "vue";

const props = withDefaults(
  defineProps<
    {
      bigger?: boolean;
    } & CommandProps
  >(),
  { bigger: false, disabled: false }
);

const iconName = computed(() =>
  typeof props.icon === "string" ? props.icon : props.icon.name
);
</script>
<style scoped lang="scss">
@use "@/assets/styles/reader.scss" as *;

.button-control {
  background-color: transparent;
  border: 2px solid transparent;
  border-radius: 6px;
  outline: none;
  cursor: pointer;
  color: var(--DM__theme-font-color);
  @include hover();
  &--disabled {
    cursor: not-allowed;
    color: var(--DM__theme-shadow-text-color);
  }
}

.material-icons--bigger {
  font-size: 40px;
}
</style>
